module.exports = __webpack_public_path__ + "media/assets/images/events/san_marco_group-9586b594520ee840e1628f8f4aa5924c.svg";